import { ArrowClockwise, Package } from '@phosphor-icons/react'

export function FullPageState({ title }: { title: string }) {
  return <div className="full-state"><span className="spinner" /><strong>{title}</strong></div>
}

export function QueryState({
  loading, error, empty, onRetry,
}: { loading?: boolean; error?: unknown; empty?: boolean; onRetry?: () => void }) {
  if (loading) return <div className="query-state"><span className="spinner" /><span>正在读取真实数据</span></div>
  if (error) return <div className="query-state is-error"><strong>数据加载失败</strong><span>{error instanceof Error ? error.message : '请稍后重试'}</span>{onRetry && <button onClick={onRetry}><ArrowClockwise />重新加载</button>}</div>
  if (empty) return <div className="query-state"><Package size={32} /><strong>暂时没有数据</strong><span>调整筛选条件后再试试</span></div>
  return null
}

export function SkeletonRows({ rows = 6 }: { rows?: number }) {
  return <>{Array.from({ length: rows }, (_, index) => <div className="skeleton-row" key={index}><i /><i /><i /><i /></div>)}</>
}
